<template>
  <svg 
    width="1em" 
    height="1em" 
    viewBox="0 0 24 24"
  >
    <g 
      stroke="currentColor" 
      stroke-width="2" 
      stroke-linecap="round" 
      stroke-linejoin="round" 
      fill="none" 
      fill-rule="evenodd"
      class="shadow_spread">
      <path d="M18,6 L6,18"/>
      <path d="M6,6 L18,18"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconClose"
};
</script>

<style lang="sass" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components/icons/IconClose.vue